import { usePatientDocumentsExpirationDateRemoveMutation } from "../../../../../api/patientDocuments/usePatientDocumentsExpirationDateRemoveMutation";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../services/UINotificationService";
import { extractApiError } from "../../../../../utilities/api";
import { getPathParams } from "../utilities";

export function useBulkRemoveExpiration() {
  var { tClients: t } = useAppTranslation.Clients();
  var { patientId } = getPathParams();

  var { mutateAsync, isLoading } =
    usePatientDocumentsExpirationDateRemoveMutation({
      onError: (res) => {
        var message = extractApiError(res);
        uiNotification.error(
          t([
            `documents.error.${message}`,
            "documents.error.mutation_fallback",
          ]),
        );
      },
      onSuccess: () => {
        uiNotification.success();
      },
    });

  return {
    isLoading,
    initiate: async (ids, type) => {
      return await mutateAsync({
        ids,
        type,
        patientId,
      });
    },
  };
}
